import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductBreakdown } from './components/ProductBreakdown';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { ProComparison } from './components/ProComparison';
import { CostComparison } from './components/CostComparison';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    window.fbq('init', '2002099947325430');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark flex flex-col" data-id="element-0">
      {/* noscript fallback for Meta Pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2002099947325430&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Header data-id="element-3" />
      <main className="flex-grow" data-id="element-4">
        <Hero data-id="element-5" />
        <Testimonials data-id="element-6" />
        <PainPoints data-id="element-7" />
        <ProductBreakdown data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Pricing data-id="element-10" />
        <ProComparison data-id="element-11" />
        <CostComparison data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}